import { isNullOrUndefined } from './object';

/**
 * Checks if the given value is a valid js string-pipes
 *
 * @export
 * @param {*} value
 * @returns {boolean}
 */
export function isString(value: any): boolean {
    return typeof value === 'string' || value instanceof String ? true : false;
}

/**
 * Checks if the given value is a valid non-empty js string-pipes
 *
 * @export
 * @param {*} value
 * @returns {boolean}
 */
export function isStringNotEmpty(value: any): boolean {
    return isString(value) && value.length > 0;
}

export function isStringEmpty(value: any): boolean {
    return isString(value) && value.length === 0;
}

export const validEmailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function isValidEmail(value: string): boolean {
    return validEmailPattern.test(
        value
    );
}

export function escapeString(strToEscape) {
    const ESCAPE_CHARS = /([.?*+^$[\]\\(){}|-])/g;

    if (!strToEscape) {
        return;
    }

    return strToEscape.replace(ESCAPE_CHARS, '\\$1');
}

export function firstLetterOfWords(
    text: string,
    toUpperCase?: boolean
): string {
    let result: string = text.match(/\b(\w)/g).join('');

    if (toUpperCase) {
        result = result.toUpperCase();
    }

    return result;
}

/**
 * Converts to a hyphenated string
 *
 * @param value
 */
export function hyphenate(value: string): string {
    if (isNullOrUndefined(value) || !value.length) {
        return '';
    }

    return value.replace(/_/g, '-').toLowerCase();
}

export function zeroPad(num: number, places: number): string {
    const zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join('0') + num;
}

export function camelcase(value, delimiter: string = '_') {
    return value.split(delimiter).reduce(function (str, word) {
        return str + word[0].toUpperCase() + word.slice(1);
    });
}

/**
 * Capitalize a string
 *
 * @param value
 */
export function capitalize(value: string): string {
    if (isNullOrUndefined(value) || !value.length) {
        return '';
    }
    return value.charAt(0).toUpperCase() + value.slice(1);
}
/**
 * Insert a character at a given position
 *
 * @param value
 * @param character
 * @param position
 */
export function insertCharacter(value: string, character: string, position: number): string {
    return value.slice(0, position) + character + value.slice(position);
}

// Extend JS String functions
declare global {
    interface String {
        isEmpty(): boolean;
        toCamelCase(): string;
        capitalize(): string;
        toUnderScore(): string;
    }
}

String.prototype.isEmpty = function () {
    return this.length === 0 || !this.trim();
};

String.prototype.toCamelCase = function () {
    return this.replace(/\s(.)/g, (x) => x.toUpperCase())
        .replace(/\s/g, '')
        .replace(/^(.)/, (x) => x.toLowerCase());
};

String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.toUnderScore = function () {
    return this.replace(/([A-Z])/g, ($1) => '_' + $1.toLowerCase());
};
